import { Table } from "antd";
import { checkNullable } from "../../../utilities/helpers";
import { get, round } from "lodash";

const PnlOverallSummary = ({ summary, templateType }) => {
  return (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0}>
        <p className="font-semibold text-center">Total</p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={1}>
        <p className="text-center">
          {checkNullable(round(get(summary, "summary.production_amount"), 2)) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={2}>
        <p className="text-center">
          {checkNullable(round(get(summary, "summary.salary_percent"), 2)) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={3}>
        <p className="text-center">
          {checkNullable(round(get(summary, "summary.salary_amount"), 2)) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={4}>
        <p className="text-center">
          {round(get(summary, "summary.job_profit"), 2) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={5}>
        <p className="text-center">
          {round(get(summary, "summary.job_profit_percent"), 2) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={6}>
        <p className="text-center">
          {" "}
          {Number(round(get(summary, "summary.sale_profit"), 2))}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={7}>
        <p className="text-center">
          {round(get(summary, "summary.sale_profit_percent"), 2) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={6}>
        <p className="text-center">
          {" "}
          {!isNaN(Number(round(get(summary, "summary.net_profit")))) ? Number(round(get(summary, "summary.net_profit"), 2)) : 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={7}>
        <p className="text-center">
          {!isNaN(round(get(summary, "summary.net_profit_percent"), 2)) ? round(get(summary, "summary.net_profit_percent"), 2) : 0}
        </p>
      </Table.Summary.Cell>
    </Table.Summary.Row>
  );

};

export default PnlOverallSummary;